export const MENU_TEXTS: { TITLE: string; PATH: string }[] = [
  { TITLE: "가입승인", PATH: "approve" },
  { TITLE: "회원 관리", PATH: "signup" },
  { TITLE: "Q&A 관리", PATH: "qna" },
  { TITLE: "게시글 관리", PATH: "post" },
  { TITLE: "챌린지 관리", PATH: "challenge" },
  { TITLE: "배너 관리", PATH: "banner" },
];
